import * as angular from "angular";
import {IController} from "angular";


export class OrderFulfillmentLinesListCtrl implements IController {

  order: any;
  fulfillmentLines: any;
  selectedLine: any;
  onSelect: Function;
}

angular
  .module('bringoz.admin.fulfillment')
  .component('orderFulfillmentLinesList', {
    bindings: {
      order: '<',
      fulfillmentLines: '<',
      selectedLine: '<',
      onSelect: '&'
    },
    template: require('./order-fulfillment-lines-list.html').default,
    controller: OrderFulfillmentLinesListCtrl
  });
